<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :width="filterInfo.width"
        :list-type-info="listTypeInfo"
        :count="filterInfo.count"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <eui-btn @click="exportStatementAccountFromSupplier">导出</eui-btn>
      <tableList
        :loading="false"
        :index-show="showIndex"
        :table-data="tableData"
        :row-key="rowKey"
        :table-label="tableLabel"
        style="margin-top: 20px"
      >
        <template v-slot:serviceCharge="slot">
          <span style="color: #EF4C56">{{ slot.scope.row.serviceFee }}</span>
        </template>
        <template v-slot:statementAccountName="slot">
          <e-tooltip
            :content="slot.scope.row.statementAccountName"
            :set-length="20"
          />
        </template>
        <template v-slot:supplierCompanyName="slot">
          <e-tooltip
            :content="slot.scope.row.supplierCompanyName"
            :set-length="12"
          />
        </template>
        <template v-slot:paymentVoucher="slot">
          <el-image
            v-if="slot.scope.row.attachmentUrl"
            style="width: 40px; height: 40px"
            :src="slot.scope.row.attachmentUrl"
            :preview-src-list="[slot.scope.row.attachmentUrl]"
          >
          </el-image>
        </template>
        <template v-slot:accountStatus="slot">
          <el-button
            type="text"
            style="color: #EF4C56;font-size: 12px"
            v-if="
              slot.scope.row.statementAccountStatus == 4 ||
                slot.scope.row.statementAccountStatus == 6
            "
            >{{ slot.scope.row.statementAccountStatusDesc }}</el-button
          >
          <el-button
            type="text"
            style="color: #00a854;font-size: 12px"
            v-else-if="slot.scope.row.statementAccountStatus == 5"
            >{{ slot.scope.row.statementAccountStatusDesc }}</el-button
          >
          <el-button
            type="text"
            style="color: #f0c78a;font-size: 12px"
            v-else
            >{{ slot.scope.row.statementAccountStatusDesc }}</el-button
          >
        </template>
        <template v-slot:operate="slot">
          <div class="font-12">
            <eui-btn
              type="link"
              font-size="12px"
              @click="handleView(slot.scope.row)"
              style="font-size: 12px"
              >查看</eui-btn
            >
            <!--  isCancelOrNot 是否有撤销 1 有 0 没有-->
            <eui-btn
              type="link"
              color="error"
              font-size="12px"
              @click="handleRejectStatement(slot.scope.row)"
              v-if="
                slot.scope.row.statementAccountStatus == 1 &&
                  !slot.scope.row.isCancelOrNot
              "
              >驳回</eui-btn
            >
            <eui-btn
              type="link"
              color="error"
              font-size="12px"
              @click="handleView(slot.scope.row)"
              v-if="slot.scope.row.statementAccountStatus == 1"
              >确认</eui-btn
            >
<!--            <eui-btn-->
<!--              type="link"-->
<!--              color="error"-->
<!--              font-size="12px"-->
<!--              @click="handleView(slot.scope.row)"-->
<!--              v-if="slot.scope.row.statementAccountStatus == 2"-->
<!--              >上传凭证</eui-btn-->
<!--            >-->
          </div>
        </template>
      </tableList>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import eSearch from '../../components/common/e-search';
import tableList from '../../components/common/e-table-list';
import api from '../../api/order';
import utils from '@/modules/projectA/utils/utils';
import eTooltip from '../../components/common/e-tooltip';

export default {
  name: 'index',
  components: { eSearch, tableList, eTooltip },
  data() {
    return {
      selectData: [],
      selectionShow: true,
      showIndex: true,
      rowKey: 'statementAccountNo',
      tableData: [],
      tableLabel: [
        {
          label: '对账单编号',
          param: 'statementAccountNo',
          align: 'center',
          width: '160',
        },
        {
          label: '对账单名称',
          param: 'statementAccountName',
          align: 'center',
          slot: 'statementAccountName',
        },
        {
          label: '服务费（元）',
          param: 'serviceFee',
          align: 'center',
          slot: 'serviceCharge',
          width: '100',
        },
        {
          label: '供应商名称',
          param: 'supplierCompanyName',
          align: 'center',
          slot: 'supplierCompanyName',
        },
        {
          label: '创建时间',
          param: 'createTime',
          align: 'center',
          width: '140',
        },
        {
          label: '对账状态',
          param: 'statementAccountStatusDesc',
          align: 'center',
          slot: 'accountStatus',
          width: '130',
        },
        {
          label: '是否集采',
          param: 'collectivePurchaseType',
          align: 'center',
          width: '140',
          render:({ collectivePurchaseType })=> {
            if(Number(collectivePurchaseType) === 1){
              return  '是'
            }
            if(Number(collectivePurchaseType) === 0){
              return  '否'
            }
          }
        },
        {
          label: '支付凭证',
          param: '',
          align: 'center',
          slot: 'paymentVoucher',
          width: '80',
        },
        {
          label: '操作',
          param: '',
          align: 'center',
          slot: 'operate',
          width: '150',
        },
      ],
      attachmentUrl: '',
      queryData: {
        statementAccountNo: null,
        statementAccountName: null,
        createTime: null,
        statementAccountStatusList: [1, 2, 3, 5, 6],
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      filterInfo: {
        data: {
          statementAccountNo: '',
          statementAccountName: '',
          createTime: '',
          statementAccountStatusList: '',
          collectivePurchaseType:null,
        },
        count: 10,
        fieldList: [
          { label: '对账单编号', type: 'input', value: 'statementAccountNo' },
          { label: '对账单名称', type: 'input', value: 'statementAccountName' },
          {
            label: '创建时间',
            type: 'date',
            value: 'createTime',
            defaultTime: ['00:00:00', '23:59:59'],
            valueFormat: 'yyyy-MM-dd',
            dateType: 'daterange',
          },
          {
            label: '对账状态',
            type: 'select',
            value: 'statementAccountStatusList',
            list: 'statusList',
          },
          {
            label: '集采/非集采',
            type: 'select',
            value: 'collectivePurchaseType',
            list: 'collectivePurchaseTypeList',
          },
        ],
      },
      listTypeInfo: {
        collectivePurchaseTypeList:[
          { id: null, name: '全部' },
          { id: 1, name: '集采' },
          { id: 0, name: '非集采' },
        ],
        statusList: [
          { id: 1, name: '待供应商确认' },
          { id: 2, name: '已确认待支付' },
          { id: 3, name: '待平台确认' },
          { id: 5, name: '完成' },
          { id: 6, name: '供应商驳回' },
        ],
      },
    };
  },
  methods: {
    handleRejectStatement(item) {
      this.$confirm('确认要驳回该对账单吗？', '提示', {
        confirmButtonText: '确认驳回',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.rejectStatement(item);
      });
    },
    //驳回对账单
    rejectStatement(item) {
      let params = {
        statementAccountId: item.statementAccountId,
        supplierCompanyId: item.supplierCompanyId,
      };
      api.rejectStatement(params).then((res) => {
        if (res.success) {
          this.$message.success('对账单已驳回！');
          this.statementAccountBackPage();
        }
      });
    },
    exportStatementAccountFromSupplier() {
      api.exportStatementAccountFromSupplier(this.queryData).then((res) => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res);
        }
      });
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.statementAccountBackPage();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.statementAccountBackPage();
    },
    handleView(row) {
      //待供应商确认 时 操作提交确认的数据封装
      let params = {
        statementAccountId: row.statementAccountId,
        statementAccountStatus: row.statementAccountStatus,
      };
      localStorage.setItem('supperConfirmData', JSON.stringify(params));
      this.$router.push({
        path: 'statementDetails',
        query: {
          statementAccountId: row.statementAccountId,
          supplierCompanyId: row.supplierCompanyId,
          isCancelOrNot: row.isCancelOrNot,
        },
      });
    },
    handleFilter(val) {
      this.queryData.statementAccountNo = val.statementAccountNo
      this.queryData.collectivePurchaseType = val.collectivePurchaseType;
      this.queryData.statementAccountName = val.statementAccountName
        ? val.statementAccountName
        : null;
      this.queryData.createTime = val.createTime ? val.createTime : null;
      this.queryData.statementAccountStatusList = val.statementAccountStatusList
        ? [val.statementAccountStatusList]
        : [1, 2, 3, 5, 6];
      this.queryData.startTime =
        val.createTime && val.createTime.length > 0 ? val.createTime[0] : null;
      this.queryData.endTime =
        val.createTime && val.createTime.length > 0 ? val.createTime[1] : null;
      this.queryData.pageNum = 1;
      this.statementAccountBackPage();
    },
    handleReset() {
      this.queryData = {
        statementAccountNo: null,
        statementAccountName: null,
        createTime: null,
        statementAccountStatusList: [1, 2, 3, 5],
        startTime: null,
        endTime: null,
        collectivePurchaseType:null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      this.statementAccountBackPage();
    },
    statementAccountBackPage() {
      api.statementAccountBackPage(this.queryData).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.queryData.pageTotal = res.data.total;
        }
      });
    },
  },
  mounted() {
    this.statementAccountBackPage();
  },
};
</script>

<style scoped lang="scss">
.line-box {
  display: flex;
}
.icon-wrapper {
  width: 30%;
  .right-line {
    border-right: 1px solid #8c939d;
    padding-right: 80px;
  }
}
::v-deep .el-button--small {
  padding: 0 0 0 10px;
  margin-left: 0;
}
</style>
